export default class extends Controller {
  static targets = ['repeatTypeSelect', 'repeatFields', 'startDateField'];

  connect() {
    App.DynamicSelect.onChange(this.repeatTypeSelectTarget, this.updateRepeatFields.bind(this));
  }

  updateRepeatFields() {
    App.Helpers.addModalHandlers(
      App.Helpers.setContentFromString(
        this.repeatFieldsTarget, document.querySelector(`[data-fields=event-repeat-${this.repeatTypeSelectTarget.value}-fields]`).innerHTML
      )
    );
    this.startDateFieldTargets.forEach(t => t.value = this.startDate);
  }

  updateStartDate(event) {
    this.startDate = event.target.value;
  }

  //
  // GETTERS AND SETTERS
  //

  get startDate() {
    return this.data.get('start-date');
  }

  set startDate(val) {
    this.data.set('start-date', val);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/campaign-brief-event-repeat-fields-controller.js